import { Spacer } from "../../component/Spacer/Spacer";
import "./InstallPage.css";

function InstallPage() {

    const instagramUrl = "https://www.instagram.com/campuspocket_official";
    const twitterUrl = "https://twitter.com/campoke_info";
    const appStoreUrl = "https://apps.apple.com/jp/app/campuspocket/id6461417915";
    const googlePlayUrl =
    "https://play.google.com/store/apps/details?id=com.campus_pocket.campus_pocket";

    return (
        <div className="login-page-container">
            <div className="login-form">
                <div className="custom-input-container">
                    <div
                        style={{
                            width: "100%",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            flexDirection: "column",
                        }}
                    >
                        <img
                            style={{
                                // height: "150px",
                                width: "300px",
                            }}
                            src="/web/images/campus-pocket-logo.png"
                            alt="Logo"
                        />
                        <Spacer size={20} />
                        <div style={{ textAlign: "center", fontSize: "20px" }}>
                            アプリをインストールして<br />Campus Pocketを始めましょう！
                        </div>
                        <Spacer size={45} />
                        {/* <div style={{ display: "flex", justifyContent: "center" }}> */}
                        <img
                            style={{
                                // height: "150px",
                                width: "200px",
                            }}
                            src="/web/images/app-store-badge.png"
                            alt="App Store"
                            onClick={() => {
                                window.open(appStoreUrl, "_blank");
                            }}
                        />
                        <Spacer size={15} />
                        <img
                            style={{
                                // height: "150px",
                                width: "200px",
                            }}
                            src="/web/images/google-play-badge.png"
                            alt="Google Play"
                            onClick={() => {
                                window.open(googlePlayUrl, "_blank");
                            }}
                        />
                        {/* </div> */}
                        <Spacer size={45} />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default InstallPage;
